import { IFetchObject } from '../actions.interface'
import { IReportSettingsDto } from './settings.interface'

const REPORT_SETTINGS_KEY = 'admin-report-settings'

export const getReportSettings = (): IFetchObject => ({
    key: REPORT_SETTINGS_KEY,
    url: `settings/report`,
    default: [],
    method: 'GET',
})

export const updateReportSettings = (values: IReportSettingsDto): IFetchObject => ({
    key: REPORT_SETTINGS_KEY,
    url: `settings/report`,
    default: [],
    method: 'PUT',
    body: values,
})

export const resetReportSetting = (settingKey: string): IFetchObject => ({
    key: REPORT_SETTINGS_KEY,
    url: `settings/report/${settingKey}`,
    default: [],
    method: 'DELETE',
})
